"use client";

import { Search } from "@/components/Search";

type SearchResult = {
  title: string;
  excerpt: string;
  url: string;
  category?: string;
};

type BlogSearchProps = {
  searchData: SearchResult[];
};

export function BlogSearch({ searchData }: BlogSearchProps) {
  return <Search items={searchData} placeholder="Search blog posts..." />;
}
